// extracted by css-extract-rspack-plugin
export default {"viewerContainer":"ExistingIssuePreview-module__viewerContainer__QhaHJ","relationshipsContainer":"ExistingIssuePreview-module__relationshipsContainer__opbRh"};